module.exports = __webpack_public_path__ + "img/activity_1_side_image.ae869f91.jpg";